import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { TranslatorService } from '../../../../core/translator.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { Municipality } from '../../municipalities/municipalities.models';
import { DeliveryZone } from '../delivery-zones.models';
import { MunicipalitiesService } from '../../municipalities/municipalities.service';
import { OptionsSource } from "../../../../core/core.models";
import { Badge } from "../../badges/badges.models";

@Component({
  selector: 'app-delivery-zones-form',
  templateUrl: './delivery-zones-form.component.html',
  styleUrls: ['./delivery-zones-form.component.scss']
})
export class DeliveryZonesFormComponent extends BaseFormComponent implements OnInit {
  municipalities: OptionsSource;
  municipalitiesUrl: string = `${Constants.contextPath}/municipalities`;

  constructor(
    private municipalitiesService: MunicipalitiesService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService)
  }

  ngOnInit(): void {
    this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.url = `${Constants.contextPath}/delivery-zones`;
    this.prepareLookupData();
    this.prepareFormData(new DeliveryZone(), (response: DeliveryZone) => {
      response.breadcrumbsId = response.name;

      if (response.municipalities) {
        // this.municipalities = response.municipalities;
      }

      return response;
    });
  }

  prepareLookupData() {
    this.municipalities = this.municipalitiesService.getMunicipalitiesOptions();
  }

  public saveChanges(): void {
    if (!this.isFormValid())
      return;

    let data = { ...this.formData };
    data.municipalities = this.formData.municipalities.map(m => m.id != undefined ? m.id : m);

    if (this.id == null)
      this.baseService.create(this.url, data, () => {
        this.onSaveSuccess();
      });
    else
      this.baseService.update(this.url, data, () => {
        this.onSaveSuccess();
      });
  }

  onMunicipalitiesChanged(event) {
    if (this.formData != null) {
      this.formData.municipalities = event;
      this.pendingChanges = true;
    }
  }

}
